module.exports = "/_next/static/images/05afbd86d3e25e22dcca6bb4259e2aa3-savings-waitlist-promise-1b-lg-1x.jpg.webp";